import { createAsyncThunk } from "@reduxjs/toolkit"

import { registerUser } from "src/store/user"
import { loadUserData } from "src/store/auth"

/* `login.js` with the first half swapped — the same shape as `loginWithGoogle.js`, and for the
   same reason.

   Registering has always been the odd one out: it took tokens and identity straight from
   `POST /users/` and stopped there, while both sign-in paths went on to `loadUserData`. That
   was invisible while the only thing it would have loaded was an empty lobby list and an empty
   game list — a brand-new account has neither. It stopped being invisible when the wallet joined
   that bootstrap: a player who had just registered had a full wallet on the server and none on
   screen, until they happened to reload. */
export const registerAndSignIn = createAsyncThunk(
  "auth/register",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      // `.unwrap()` so a rejected registration — a taken username, a weak password — reaches the
      // form as the server's field errors instead of being swallowed and followed by a bootstrap
      // for a session that does not exist.
      await dispatch(registerUser(data)).unwrap()
      await dispatch(loadUserData())
      return
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
